<template>
    <div class="fs-templates">
      <ul class="template-tabs">
        <li
          v-for="template in templates"
          :key="template.id"
          :class="{ active: template.id === activeTemplate }"
          @click="selectTemplate(template.id)"
        >
          {{ template.name }}
        </li>
      </ul>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  
  const templates = ref([
    { id: 1, name: 'Vorlage 1' },
    { id: 2, name: 'Vorlage 2' },
    { id: 3, name: 'Vorlage 3' }
  ])
  
  const activeTemplate = ref(1)
  
  function selectTemplate(id) {
    activeTemplate.value = id
    console.log('Ausgewählte Vorlage:', id)
  }
  </script>
  
  <style scoped>
  .fs-templates {
    border-bottom: 1px solid #ccc;
    padding: 10px;
  }
  
  .template-tabs {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .template-tabs li {
    margin-right: 15px;
    padding: 5px 10px;
    cursor: pointer;
  }
  
  .template-tabs li.active {
    font-weight: bold;
    border-bottom: 2px solid #000;
  }
  </style>
  